module.exports = __webpack_public_path__ + "img/start.5abba675.png";